import { FormGroup, Validators, FormControl } from "@angular/forms";

export class HarvestReportFormGroup extends FormGroup {
    constructor() {
        const controlSet = {
            startDate: new FormControl(null, Validators.required),
            endDate: new FormControl(null, Validators.required),
            crop: new FormControl()
        };
        super(controlSet);

        this._startDate = controlSet.startDate;
        this._endDate = controlSet.endDate;
        this._crop = controlSet.crop;
    }

    private _startDate: FormControl;
    private _endDate: FormControl;
    private _crop: FormControl;

    public get startDateFormControl(): FormControl {
        return this._startDate;
    }

    public get endDateFormControl(): FormControl {
        return this._endDate;
    }

    public get cropFormControl(): FormControl {
        return this._crop;
    }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/reporting/harvest-report-form/harvest-report-form-group.ts